<template>
  <b-overlay :show="show">
    <div class="my-register-page" style="font-size: 13px">
      <div class="my-container">
        <b-row class="mb-2">
          <b-col>
            <h1>{{ pageTitle }}</h1>
          </b-col>
        </b-row>

        <div class="cardStyleEdit mb-3" style="padding: 24px">
          <b-row>
            <b-col cols="12">
              <h5 class="styleText mb-3">{{ $t("inn") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="8">
              <custom-input type="number" :placeholder="$t('inn')" v-model="searchInn" :label="$t('inn')"
                @keyup.native.enter="SearchByInnOrPinfl"></custom-input>
            </b-col>
            <b-col cols="12" sm="12" md="4" class="d-flex align-items-end">
              <b-button variant="primary" style="width:100%" :disabled="isSearching" @click="SearchByInnOrPinfl">
                <b-spinner v-if="isSearching" small></b-spinner>
                {{ $t("search") }}
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" sm="12" md="12">
              <custom-input disabled :placeholder="$t('name')" v-model="Request.contractor.fullName"
                :label="$t('name')"></custom-input>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" sm="12" md="6">
              <custom-input disabled :placeholder="$t('oblast')" v-model="Request.contractor.region"
                :label="$t('oblast')"></custom-input>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <custom-input disabled :placeholder="$t('region')" v-model="Request.contractor.district"
                :label="$t('region')"></custom-input>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" sm="12" md="12">
              <custom-input disabled :placeholder="$t('oked')" v-model="Request.contractor.oked"
                :label="$t('oked')"></custom-input>
            </b-col>
          </b-row>
        </div>

        <template v-if="searched">
          <div class="ib-punkt-list">
          <div v-if="showControlPart && !isCriminal" class="cardStyleEdit mb-3 mt-4 pt-2">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ punktNumber(1) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12" sm="12" md="6">
                <custom-input disabled :placeholder="$t('orderCode')" v-model="Request.orderCode"
                  :label="$t('orderCode')"></custom-input>
              </b-col>
            </b-row>
          </div>
          <div v-if="showControlPart && !isCriminal" class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ punktNumber(2) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col cols="12" sm="12" md="6" class="mb-3">
                <v-select :disabled="controlDisabled" :placeholder="$t('orderedOrganization')" class="my-select"
                  :options="ParentList" :reduce="(item) => item.value" label="text"
                  v-model="Request.orderedOrganizationId" @input="ChangeOrganization"></v-select>
              </b-col>
              <b-col cols="12" sm="12" md="6" class="mb-3">
                <v-select :disabled="controlDisabled" :placeholder="$t('inspectionOrganization')" class="my-select"
                  :options="OrganizationList" :reduce="(item) => item.value" label="text"
                  v-model="Request.inspectionOrganizationId" @input="ChangeInspectionOrganization"></v-select>
              </b-col>
            </b-row>
            <!-- <b-row class="mt-2">
              <b-col cols="12" sm="12" md="12">
                <custom-input :disabled="controlDisabled" :placeholder="$t('authorizedOrganization')"
                  v-model="Request.authorizedOrganization" :label="$t('authorizedOrganization')"></custom-input>
              </b-col>
            </b-row> -->
            <b-row class="mt-3">
              <b-col cols="12" sm="12" md="6">
                <custom-input :disabled="controlDisabled" :placeholder="$t('inspectionOrganizationAddres')"
                  v-model="Request.inspectionOrganizationAddres"
                  :label="$t('inspectionOrganizationAddres')"></custom-input>
              </b-col>
              <b-col cols="12" sm="12" md="6">
                <custom-input :disabled="controlDisabled" :placeholder="$t('inspectionOrganizationName')"
                  v-model="Request.inspectionOrganizationName" :label="$t('inspectionOrganizationName')"></custom-input>
              </b-col>
              <b-col cols="12" sm="12" md="6" class="mt-2">
                <custom-input :disabled="controlDisabled" :placeholder="$t('inspectionOrganizationPostalAddres')"
                  v-model="Request.inspectionOrganizationPostalAddres"
                  :label="$t('inspectionOrganizationPostalAddres')"></custom-input>
              </b-col>
              <b-col cols="12" sm="12" md="6" class="mt-2">
                <custom-input :disabled="controlDisabled" :placeholder="$t('inspectionOrganizationCeo')"
                  v-model="Request.inspectionOrganizationCeo" :label="$t('inspectionOrganizationCeo')"></custom-input>
              </b-col>
            </b-row>
          </div>

          <div v-if="showControlPart" class="cardStyleEdit mb-3" :style="punktStyle(3)">
            <b-row>
              <b-col class="mt-2 mb-2" style="text-align: left">
                <h5 class="styleText">{{ punktNumber(3) }} - {{ $t("punkt") }}</h5>
              </b-col>
              <b-col
                v-if="!controlDisabled"
                class="mt-2 mb-2"
                style="text-align: right"
              >
                <b-button
                  v-if="!controlDisabled"
                  @click="AddNewInspectors"
                  style="width: 150px"
                  variant="outline-primary"
                >
                  {{ $t("Add") }}
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table-simple bordered responsive>
                  <b-tbody>
                    <b-tr variant="primary">
                      <b-td colspan="6" class="text-center">
                        <span style="font-size: 18px; font-weight: bold">{{
                          $t("inspectors")
                        }}</span>
                      </b-td>
                    </b-tr>
                    <b-tr variant="primary">
                      <b-td>
                        <span style="font-size: 14px; font-weight: bold">
                          {{ $t("employeeName") }}
                        </span>
                      </b-td>
                      <b-td
                        ><span style="font-size: 14px; font-weight: bold">
                          {{ $t("dutyNumberInspector1") }}
                        </span>
                      </b-td>
                      <b-td
                        ><span style="font-size: 14px; font-weight: bold">
                          {{ $t("dutyExpirationInspector") }}
                        </span>
                      </b-td>
                      <b-td style="min-width:200px !important">
                        <span style="font-size: 14px; font-weight: bold;">
                          {{ $t("certificateNumber1") }}
                        </span>
                      </b-td>
                      <b-td
                        ><span style="font-size: 14px; font-weight: bold">
                          {{ $t("certificateExpiration1") }}
                        </span>
                      </b-td>
                      <b-td
                        ><span style="font-size: 14px; font-weight: bold">
                          {{ $t("actions") }}
                        </span>
                      </b-td>
                    </b-tr>
                    <b-tr
                      style="background-color: white"
                      v-for="(item, index) in RequestTable"
                      :key="index"
                    >
                      <b-td>
                        {{ item.fullName }}
                      </b-td>
                      <b-td>
                        <custom-input
                          :label="$t('')"
                          :disabled="controlDisabled"
                          :placeholder="$t('dutyNumberInspector1')"
                          v-model="item.dutyNumber"
                        ></custom-input>
                      </b-td>
                      <b-td>
                        <custom-date-picker
                          :disabled="controlDisabled"
                          :label="$t('dutyExpirationInspector')"
                          placeholder="00.00.0000"
                          v-model="item.dutyExpiration"
                        ></custom-date-picker>
                      </b-td>
                      <b-td>
                        <custom-input
                          :label="$t('')"
                          :disabled="controlDisabled"
                          :placeholder="$t('certificateNumber1')"
                          v-model="item.certificateNumber"
                        ></custom-input>
                      </b-td>
                      <b-td>
                        <custom-date-picker
                          :disabled="controlDisabled"
                          :label="$t('certificateExpiration1')"
                          placeholder="00.00.0000"
                          v-model="item.certificateExpiration"
                        ></custom-date-picker>
                      </b-td>
                      <b-td class="text-center">
                        <b-link
                          v-if="!controlDisabled"
                          @click="DeleteInspector(item, index)"
                        >
                          <b-icon font-scale="1.5" icon="trash"></b-icon>
                        </b-link>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
          </div>

          <div v-if="showControlPart" class="cardStyleEdit mb-3" :style="punktStyle(4)">
            <b-row>
              <b-col class="mt-2 mb-2" style="text-align: left">
                <h5 class="styleText">{{ punktNumber(4) }} - {{ $t("punkt") }}</h5>
              </b-col>
              <b-col class="mt-2 mb-2" style="text-align: right">
                <b-button v-if="!controlDisabled" @click="AddInspectors" style="width: 150px" variant="outline-primary">
                  {{ $t("Add") }}
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table-simple bordered responsive>
                  <b-tbody>
                    <b-tr variant="primary">
                      <b-td colspan="10" class="text-center">
                        <span style="font-size: 18px; font-weight: bold">{{
                          $t("involvedInspectors")
                        }}</span>
                      </b-td>
                    </b-tr>
                    <b-tr variant="primary">
                      <b-td>{{ $t("organizationName") }}</b-td>
                      <b-td>{{ $t("address") }}</b-td>
                      <b-td>{{ $t("inspectorFullName") }}</b-td>
                      <b-td>{{ isCriminal ? $t("contractNumber") : $t("dutyNumber") }}</b-td>
                      <b-td>{{ isCriminal ? $t("contractExpiration") : $t("dutyExpiration") }}</b-td>
                      <b-td>{{ $t("dutyIssuingOrganization") }}</b-td>
                      <b-td>{{ $t("certificateNumber") }}</b-td>
                      <b-td>{{ $t("certificateIssuingOrganization") }}</b-td>
                      <b-td>{{ $t("certificateExpiration") }}</b-td>
                      <b-td>{{ $t("actions") }}</b-td>
                    </b-tr>
                    <b-tr style="background-color:white" v-for="(item, index) in Request.involvedInspectors" :key="index">
                      <b-td>{{ item.organizationName }}</b-td>
                      <b-td>{{ item.address }}</b-td>
                      <b-td>{{ item.inspectorFullName }}</b-td>
                      <b-td>{{ isCriminal ? item.contractNumber : item.dutyNumber }}</b-td>
                      <b-td>{{ isCriminal ? item.contractExpiration : item.dutyExpiration }}</b-td>
                      <b-td>{{ item.dutyIssuingOrganization }}</b-td>
                      <b-td>{{ item.certificateNumber }}</b-td>
                      <b-td>{{ item.certificateIssuingOrganization }}</b-td>
                      <b-td>{{ item.certificateExpiration }}</b-td>
                      <b-td class="text-center">
                        <b-link v-if="!controlDisabled" @click="EditInvolvedInspector(item)">
                          <b-icon font-scale="1.2" icon="pencil"></b-icon>
                        </b-link>
                        <b-link v-if="!controlDisabled" @click="DeleteInvolvedInspector(index)">
                          <b-icon font-scale="1.2" icon="trash"></b-icon>
                        </b-link>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="mt-2 mb-2" style="text-align: right">
                <b-button v-if="!controlDisabled" @click="AddAuditors" style="width: 150px" variant="outline-primary">
                  {{ $t("Add") }}
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table-simple bordered responsive>
                  <b-tbody>
                    <b-tr variant="primary">
                      <b-td colspan="8" class="text-center">
                        <span style="font-size: 18px; font-weight: bold">{{
                          $t("InvolvedAuditors")
                        }}</span>
                      </b-td>
                    </b-tr>
                    <b-tr variant="primary">
                      <b-td>{{ $t("organizationName") }}</b-td>
                      <b-td>{{ $t("licenseDate") }}</b-td>
                      <b-td>{{ $t("licenseNumber") }}</b-td>
                      <b-td>{{ $t("licenseExpiration") }}</b-td>
                      <b-td>{{ $t("auditorFullName") }}</b-td>
                      <b-td>{{ $t("contractNumber") }}</b-td>
                      <b-td>{{ $t("contractExpiration") }}</b-td>
                      <b-td>{{ $t("actions") }}</b-td>
                    </b-tr>
                    <b-tr style="background-color:white" v-for="(item, index) in Request.involvedAuditors" :key="index">
                      <b-td>{{ item.organizationName }}</b-td>
                      <b-td>{{ item.licenseDate }}</b-td>
                      <b-td>{{ item.licenseNumber }}</b-td>
                      <b-td>{{ item.licenseExpiration }}</b-td>
                      <b-td>{{ item.auditorFullName }}</b-td>
                      <b-td>{{ item.contractNumber }}</b-td>
                      <b-td>{{ item.contractExpiration }}</b-td>
                      <b-td class="text-center">
                        <b-link v-if="!controlDisabled" @click="EditAuditors(item)">
                          <b-icon font-scale="1.2" icon="pencil"></b-icon>
                        </b-link>
                        <b-link v-if="!controlDisabled" @click="DeleteAuditors(index)">
                          <b-icon font-scale="1.2" icon="trash"></b-icon>
                        </b-link>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="mt-2 mb-2" style="text-align: right">
                <b-button v-if="!controlDisabled" @click="AddSpecialists" style="width: 150px" variant="outline-primary">
                  {{ $t("Add") }}
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="5" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("specialists")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("inspectorsName") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractNumber1") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("identificationDocument") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractExpiration") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("actions") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.specialists"
                    :key="index"
                  >
                    <b-td>
                      {{ item.fullName }}
                    </b-td>

                    <b-td>
                      {{ item.contractNumber }}
                    </b-td>
                    <b-td>
                      {{ item.identificationDocument }}
                    </b-td>

                    <b-td>
                      {{ item.contractExpiration }}
                    </b-td>
                    <b-td class="text-center">
                      <b-link
                        v-if="
                          !(
                            $route.query.contractor == true ||
                            $route.query.contractor == 'true'
                          )
                        "
                        @click="EditSpecialists(item)"
                      >
                        <b-icon font-scale="1.2" icon="pencil"></b-icon>
                      </b-link>
                      <b-link
                        v-if="
                          !(
                            $route.query.contractor == true ||
                            $route.query.contractor == 'true'
                          )
                        "
                        @click="DeleteSpecialists(item, index)"
                      >
                        <b-icon font-scale="1.2" icon="trash"></b-icon>
                      </b-link>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              </b-col>
            </b-row>
          </div>

          <div v-if="showControlPart" class="cardStyleEdit mb-3" :class="{ 'mt-4 pt-2': isCriminal }"
            :style="punktStyle(5)">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ punktNumber(5) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col v-if="isCriminal" cols="12" sm="12" md="12" class="mb-3">
                <custom-textarea class="inputStyle" :disabled="controlDisabled" :placeholder="$t('criminalCaseInfo')"
                  v-model="Request.criminalCaseInfo" :label="$t('criminalCaseInfo')"></custom-textarea>
              </b-col>
              <b-col v-if="showDocNumber5" cols="12" sm="12" md="4" class="mb-3">
                <custom-input class="inputStyle" :disabled="controlDisabled" v-mask="'###-###-###'"
                  :placeholder="$t('docNumber5')" v-model="Request.docNumber" :label="$t('docNumber5')"></custom-input>
              </b-col>
              <b-col cols="12" sm="12" :md="showDocNumber5 ? 4 : 6" class="mb-3">
                <custom-input class="inputStyle" :disabled="controlDisabled" :placeholder="$t('orderNumber5')"
                  v-model="Request.orderNumber" :label="$t('orderNumber5')"></custom-input>
              </b-col>
              <b-col cols="12" sm="12" :md="showDocNumber5 ? 4 : 6" class="mb-3">
                <custom-date-picker :disabled="controlDisabled" :label="$t('orderDate5')" placeholder="00.00.0000"
                  v-model="Request.orderDate"></custom-date-picker>
              </b-col>
              <b-col v-if="!isCriminal" cols="12" sm="12" md="12">
                <custom-textarea class="inputStyle" :disabled="controlDisabled" :placeholder="$t('criminalCaseInfo')"
                  v-model="Request.criminalCaseInfo" :label="$t('criminalCaseInfo')"></custom-textarea>
              </b-col>
            </b-row>
          </div>

          <div v-if="showControlPart && !isCriminal" class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ punktNumber(6) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="12">
                <v-select :disabled="controlDisabled" multiple :placeholder="$t('controlFunctions')" class="my-select"
                  :options="ControlFunctionList" :reduce="(item) => item.value" label="text"
                  v-model="Request.controlFunctions"></v-select>
              </b-col>
            </b-row>
          </div>

          <div v-if="showControlPart" class="cardStyleEdit mb-3" :style="punktStyle(7)">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ punktNumber(7) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12" sm="12" md="4">
                <custom-date-picker :disabled="controlDisabled" :label="$t('startDate')" placeholder="00.00.0000"
                  v-model="Request.startDate"></custom-date-picker>
              </b-col>
              <b-col cols="12" sm="12" md="4">
                <custom-date-picker :disabled="controlDisabled" :label="$t('endDate')" placeholder="00.00.0000"
                  v-model="Request.endDate"></custom-date-picker>
              </b-col>
              <b-col cols="12" sm="12" md="4">
                <custom-input :disabled="controlDisabled" placeholder="0" v-model="Request.checkDaysNumber"
                  :label="$t('checkDaysNumber')"></custom-input>
              </b-col>
            </b-row>
          </div>
          </div>

          <div v-if="showContractorPart" class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ contractorPunktNumber(1) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12" sm="12" md="6">
                <custom-date-picker :disabled="contractorDisabled" :label="$t('contractorStartDate')"
                  placeholder="00.00.0000" v-model="Request.contractorStartDate"></custom-date-picker>
              </b-col>
              <b-col cols="12" sm="12" md="6">
                <custom-date-picker :disabled="contractorDisabled" :label="$t('contractorEndDate')"
                  placeholder="00.00.0000" v-model="Request.contractorEndDate"></custom-date-picker>
              </b-col>
            </b-row>
          </div>

          <div v-if="showContractorPart" class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ contractorPunktNumber(2) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12" sm="12" md="4">
                <custom-input :disabled="contractorDisabled" placeholder="0" v-model="Request.contractorCheckDaysNumber"
                  :label="$t('ContractorCheckDaysNumber')"></custom-input>
              </b-col>
            </b-row>
          </div>

          <div v-if="showContractorPart" class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ contractorPunktNumber(3) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12" sm="12" md="12">
                <custom-textarea :disabled="contractorDisabled" :placeholder="$t('requestedDocuments')"
                  v-model="Request.requestedDocuments" :label="$t('requestedDocuments')"></custom-textarea>
              </b-col>
            </b-row>
          </div>

          <div v-if="showContractorPart" class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ contractorPunktNumber(4) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12" sm="12" md="12">
                <custom-textarea :disabled="contractorDisabled" :placeholder="$t('takenMeasures')"
                  v-model="Request.takenMeasures" :label="$t('takenMeasures')"></custom-textarea>
              </b-col>
            </b-row>
          </div>

          <div v-if="showContractorPart" class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ contractorPunktNumber(5) }} - {{ $t("punkt") }}</h5>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12" sm="12" md="12">
                <custom-textarea :disabled="contractorDisabled" :placeholder="$t('thirdPartyInfo')"
                  v-model="Request.thirdPartyInfo" :label="$t('thirdPartyInfo')"></custom-textarea>
              </b-col>
            </b-row>
          </div>

          <div v-if="showContractorPart" class="cardStyleEdit mb-3">
            <b-row>
              <b-col>
                <h5 class="styleText">{{ $t("comment") }}</h5>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col cols="12" sm="12" md="12">
                <custom-textarea :disabled="contractorDisabled" :placeholder="$t('comment')" v-model="Request.comment"
                  :label="$t('comment')"></custom-textarea>
              </b-col>
              <!-- <b-col class="mt-2" cols="12" sm="12" md="4">
                <b-form-rating :disabled="contractorDisabled" v-model="Request.rate" variant="warning"></b-form-rating>
              </b-col> -->
            </b-row>
          </div>
<!-- Request.docNumber -->
          <section v-if="false" class="rt-card mb-3">
            <div class="rt-card-head">
              <h2>
                {{ $t("RatingStep2") || "Baholash" }}
              </h2>
              <span class="rt-hint">
                {{ $t("RatingStep2Hint") || "5 ballik tizim" }} ·
                {{ $t("CommentOptional") || "Izoh majburiy emas" }}
              </span>
            </div>
            <div class="rt-card-body">
              <div v-if="rating.alreadyRated" class="rt-already">
                <i class="fas fa-check-circle"></i>
                {{ $t("RatingAlreadySubmitted") || "Baholash yuborilgan" }}
              </div>

              <div class="rt-rate-block">
                <div class="rt-stars">
                  <button
                    v-for="n in 5"
                    :key="'i' + n"
                    type="button"
                    class="rt-star"
                    :class="{ filled: n <= rating.inspectionRating }"
                    :disabled="rating.alreadyRated || rating.submitting"
                    @click="rating.alreadyRated || (rating.inspectionRating = n)"
                  >
                    <i class="fas fa-star"></i>
                  </button>
                  <strong class="rt-stars-val">{{ rating.inspectionRating }} / 5</strong>
                </div>
                <textarea
                  v-model="rating.inspectionComment"
                  class="rt-comment"
                  maxlength="500"
                  :disabled="rating.alreadyRated || rating.submitting"
                  :placeholder="
                    $t('InspectionCommentPh') ||
                      'Tekshiruv jarayoni haqida izoh (ixtiyoriy)'
                  "
                ></textarea>
              </div>

              <div v-if="rating.inspectors.length" class="rt-rate-block">
                <div class="rt-who">
                  <div class="rt-who-icon"><i class="fas fa-users"></i></div>
                  <div>
                    <div class="rt-who-lbl">
                      {{
                        $t("InspectorsInThisInspection") ||
                          "Tekshiruvda qatnashgan tekshiruvchilar"
                      }}
                    </div>
                    <div class="rt-who-nm">
                      {{ $t("RateAllInspectorsTogether") || "Hammasi uchun umumiy baho" }}
                    </div>
                  </div>
                </div>
                <ul class="rt-insp-names">
                  <li v-for="(nm, idx) in rating.inspectors" :key="'ins-' + idx">
                    <i class="far fa-user"></i> {{ nm }}
                  </li>
                </ul>
                <div class="rt-stars">
                  <button
                    v-for="n in 5"
                    :key="'all' + n"
                    type="button"
                    class="rt-star"
                    :class="{ filled: n <= rating.inspectorsRating }"
                    :disabled="rating.alreadyRated || rating.submitting"
                    @click="rating.alreadyRated || (rating.inspectorsRating = n)"
                  >
                    <i class="fas fa-star"></i>
                  </button>
                  <strong class="rt-stars-val">{{ rating.inspectorsRating }} / 5</strong>
                </div>
                <textarea
                  v-model="rating.inspectorsComment"
                  class="rt-comment"
                  maxlength="500"
                  :disabled="rating.alreadyRated || rating.submitting"
                  :placeholder="
                    $t('InspectorCommentPh') ||
                      'Tekshiruvchilar haqida izoh (ixtiyoriy)'
                  "
                ></textarea>
              </div>
            </div>

            <div v-if="rating.error" class="rt-error" style="margin: 0 22px 12px">
              <i class="fas fa-exclamation-circle"></i> {{ rating.error }}
            </div>

            <div v-if="!rating.alreadyRated" class="rt-actions">
              <button
                type="button"
                class="rt-btn primary"
                :disabled="!canSubmitRating || rating.submitting"
                @click="submitRating"
              >
                <i v-if="rating.submitting" class="fas fa-spinner fa-spin"></i>
                <template v-else>
                  {{ $t("Submit") || "Yuborish" }}
                  <i class="fas fa-arrow-right"></i>
                </template>
              </button>
            </div>
          </section>

          <b-row class="mb-3">
            <b-col cols="6">
              <b-button @click="back" style="width: 150px" variant="outline-danger">
                {{ $t("back") }}
              </b-button>
            </b-col>
            <b-col cols="6" style="text-align: right">
              <b-button v-if="Request.statusId != 2" @click="SaveData" style="width: 150px" variant="outline-success"
                :disabled="isSave">
                <b-spinner v-if="isSave" small></b-spinner>
                {{ $t("save") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </div>

      <b-modal
        v-model="modalInspectorsInfo"
        hide-footer
        size="lg"
        no-close-on-backdrop
        hide-header
        centered
      >
        <div
          style="
            text-align: right;
            margin-right: 10px;
            margin-top: -5px;
            margin-bottom: 5px;
            border-bottom: 1px solid lightgray;
          "
        >
          <span
            @click="modalInspectorsInfo = false"
            style="cursor: pointer; font-size: 30px"
          >
            &times;
          </span>
        </div>
        <div class="mb-2">
          <custom-input
            :placeholder="$t('search')"
            v-model="filter1.search"
            :label="$t('search')"
            @keyup.enter="AddNewInspectors"
            @input="AddNewInspectors"
          ></custom-input>
        </div>
        <b-table :items="items" bordered :fields="fields">
          <template #cell(isSelected)="{ item }">
            <div class="text-center">
              <b-form-checkbox v-model="item.isSelected"></b-form-checkbox>
            </div>
          </template>
        </b-table>

        <div>
          <b-pagination
            v-model="filter1.page"
            :total-rows="filter1.totalRows"
            :per-page="filter1.pageSize"
            first-number
            last-number
            @input="AddNewInspectors"
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <b-icon icon="chevron-double-left" size="18" />
            </template>
            <template #next-text>
              <b-icon icon="chevron-double-right" size="18" />
            </template>
          </b-pagination>
        </div>
        <div style="text-align: right">
          <b-button
            variant="outline-success"
            :disabled="isSave"
            @click="AddInspectorsTableInfo"
          >
            <b-spinner
              style="margin-left: 20px"
              v-if="isSave"
              small
            ></b-spinner>
            {{ $t("save") }}
          </b-button>
        </div>
      </b-modal>

      <b-modal size="lg" v-model="modal" hide-footer hide-header no-close-on-backdrop>
        <b-row>
          <b-col>
            <h5>{{ $t("Add") }}</h5>
          </b-col>
        </b-row>
       <b-row class="backColor">
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                :placeholder="$t('inspectorsName')"
                v-model="tabrow.fullName"
                :label="$t('inspectorsName')"
              ></custom-input>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                :placeholder="$t('contractNumber1')"
                v-model="tabrow.contractNumber"
                :label="$t('contractNumber1')"
              ></custom-input>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                type="text"
                :placeholder="$t('identificationDocument')"
                v-model="tabrow.identificationDocument"
                :label="$t('identificationDocument')"
              ></custom-input>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1 mb-1">
              <custom-date-picker
                :label="$t('contractExpiration')"
                placeholder="00.00.0000"
                v-model="tabrow.contractExpiration"
              ></custom-date-picker>
            </b-col>
          </b-row>
        <b-row class="mt-2">
          <div style="text-align: right" class="mr-2">
            <b-button style="margin-right:5px" variant="outline-danger" @click="BackModal">
              {{ $t("back") }}
            </b-button>
            <b-button variant="outline-success" @click="AddOked">
              {{ $t("save") }}
            </b-button>
          </div>
        </b-row>
      </b-modal>

      <b-modal size="lg" v-model="modalAuditors" hide-footer hide-header no-close-on-backdrop>
        <b-row>
          <b-col>
            <h5>{{ $t("InvolvedAuditors") }}</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="12" class="mt-1">
            <custom-input :placeholder="$t('organizationNameAuditor')" v-model="tabrowAuditors.organizationName"
              :label="$t('organizationNameAuditor')"></custom-input>
          </b-col>
          <b-col sm="12" lg="12" class="mt-1">
            <custom-date-picker :label="$t('licenseDate')" placeholder="00.00.0000"
              v-model="tabrowAuditors.licenseDate"></custom-date-picker>
          </b-col>
          <b-col sm="12" lg="12" class="mt-1">
            <custom-input :placeholder="$t('licenseNumber')" v-model="tabrowAuditors.licenseNumber"
              :label="$t('licenseNumber')"></custom-input>
          </b-col>
          <b-col sm="12" lg="12" class="mt-1">
            <custom-date-picker :label="$t('licenseExpiration')" placeholder="00.00.0000"
              v-model="tabrowAuditors.licenseExpiration"></custom-date-picker>
          </b-col>
          <b-col sm="12" lg="12" class="mt-1">
            <custom-input :placeholder="$t('auditorFullName')" v-model="tabrowAuditors.auditorFullName"
              :label="$t('auditorFullName')"></custom-input>
          </b-col>
          <b-col sm="12" lg="12" class="mt-1">
            <custom-input :placeholder="$t('contractNumber')" v-model="tabrowAuditors.contractNumber"
              :label="$t('contractNumber')"></custom-input>
          </b-col>
          <b-col sm="12" lg="12" class="mt-1">
            <custom-date-picker :label="$t('contractExpiration')" placeholder="00.00.0000"
              v-model="tabrowAuditors.contractExpiration"></custom-date-picker>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <div style="text-align: right" class="mr-2">
            <b-button variant="outline-danger" style="margin-right:5px" @click="modalAuditorsClose">
              {{ $t("back") }}
            </b-button>
            <b-button variant="outline-success" @click="AddAuditorsTable">
              {{ $t("save") }}
            </b-button>
          </div>
        </b-row>
      </b-modal>

      <b-modal
          size="lg"
          v-model="modalInspectors"
          hide-footer
          hide-header
          no-close-on-backdrop
        >
          <b-row>
            <b-col>
              <h5>{{ $t("involvedInspectors") }}</h5>
            </b-col>
          </b-row>
          <b-row class="backColor">
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                :placeholder="$t('organizationName')"
                v-model="tabrowInspectors.organizationName"
                :label="$t('organizationName')"
              ></custom-input>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                :placeholder="$t('address')"
                v-model="tabrowInspectors.address"
                :label="$t('address')"
              ></custom-input>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                :placeholder="$t('inspectorFullName')"
                v-model="tabrowInspectors.inspectorFullName"
                :label="$t('inspectorFullName')"
              ></custom-input>
            </b-col>
            <b-col v-if="!isCriminal" sm="12" lg="12" class="mt-1">
              <custom-input
                :placeholder="$t('dutyNumberInspector1')"
                v-model="tabrowInspectors.dutyNumber"
                :label="$t('dutyNumberInspector1')"
              ></custom-input>
            </b-col>
            <b-col v-if="!isCriminal" sm="12" lg="12" class="mt-1">
              <custom-date-picker
                :label="$t('dutyExpirationInspector')"
                placeholder="00.00.0000"
                v-model="tabrowInspectors.dutyExpiration"
              ></custom-date-picker>
            </b-col>
            <b-col v-if="isCriminal" sm="12" lg="12" class="mt-1">
              <custom-input
                :placeholder="$t('contractNumber')"
                v-model="tabrowInspectors.contractNumber"
                :label="$t('contractNumber')"
              ></custom-input>
            </b-col>
            <b-col v-if="isCriminal" sm="12" lg="12" class="mt-1">
              <custom-date-picker
                :label="$t('contractExpiration')"
                placeholder="00.00.0000"
                v-model="tabrowInspectors.contractExpiration"
              ></custom-date-picker>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                type="text"
                :placeholder="$t('dutyIssuingOrganization')"
                v-model="tabrowInspectors.dutyIssuingOrganization"
                :label="$t('dutyIssuingOrganization')"
              ></custom-input>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                type="text"
                :placeholder="$t('certificateNumber1')"
                v-model="tabrowInspectors.certificateNumber"
                :label="$t('certificateNumber1')"
              ></custom-input>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1">
              <custom-input
                type="text"
                :placeholder="$t('certificateIssuingOrganization')"
                v-model="tabrowInspectors.certificateIssuingOrganization"
                :label="$t('certificateIssuingOrganization')"
              ></custom-input>
            </b-col>
            <b-col sm="12" lg="12" class="mt-1 mb-1">
              <custom-date-picker
                :label="$t('certificateExpiration')"
                placeholder="00.00.0000"
                v-model="tabrowInspectors.certificateExpiration"
              ></custom-date-picker>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <div style="text-align: right" class="mr-2">
              <b-button
                class="mr-2"
                style="margin-right: 5px"
                variant="outline-danger"
                :disabled="isSave"
                @click="modalInspectorsClose"
              >
                <b-spinner
                  style="margin-left: 20px"
                  v-if="isSave"
                  small
                ></b-spinner>
                {{ $t("back") }}
              </b-button>
              <b-button
                class="ml-2"
                variant="outline-success"
                :disabled="isSave"
                @click="AddInspectorsTable"
              >
                <b-spinner
                  style="margin-left: 20px"
                  v-if="isSave"
                  small
                ></b-spinner>
                {{ $t("save") }}
              </b-button>
            </div>
          </b-row>
        </b-modal>
    </div>
  </b-overlay>
</template>

<script>
import InspectionBookService from "@/services/inspectionbook.service";
import CriminalCaseInspectionService from "@/services/criminalcaseinspection.service";
import RequestRatingService from "@/services/requestrating.service";
import ControlFunctionService from "@/services/controlfunction.service";
import ManualService from "@/services/manual.service";
import InspectorService from "@/services/inspector.service";
import customDatePicker from "../../components/elements/customDatePicker.vue";
import customInput from "../../components/elements/customInput.vue";
import customTextarea from "../../components/elements/customTextarea.vue";
import vSelect from "vue-select";
import "bootstrap-vue/dist/bootstrap-vue.css";
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BBadge,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BLink,
  BOverlay,
  BFormRating,
} from "bootstrap-vue";

// stage === "criminal" bo'lganda: 5-punkt 1-punktga, qolganlari suriladi
const CRIMINAL_PUNKT_ORDER = { 5: 1, 3: 2, 4: 3, 7: 4 };

const emptyContractor = () => ({
  innOrPinfl: "",
  fullName: "",
  region: "",
  district: "",
  oked: "",
});

const emptyRequest = () => ({
  id: 0,
  statusId: 0,
  requestId: null,
  contractor: emptyContractor(),
  orderCode: "",
  sequenceNumber: "",
  inspectionTypeId: null,
  message: "",
  orderedOrganizationId: null,
  inspectionOrganizationId: null,
  orderedOrganization: "",
  inspectionOrganization: "",
  authorizedOrganization: "",
  inspectionOrganizationName: "",
  inspectionOrganizationCeo: "",
  inspectionOrganizationPostalAddres: "",
  inspectionOrganizationAddres: "",
  criminalCaseInfo: "",
  docNumber: "",
  orderNumber: "",
  orderDate: "",
  docDate: "",
  startDate: "",
  endDate: "",
  checkDaysNumber: 0,
  contractorStartDate: "",
  contractorEndDate: "",
  contractorCheckDaysNumber: 0,
  requestedDocuments: "",
  takenMeasures: "",
  thirdPartyInfo: "",
  comment: "",
  rate: 0,
  controlFunctions: [],
  involvedInspectors: [],
  involvedAuditors: [],
  specialists: [],
  inspectors: [],
});

export default {
  data() {
    return {
      Request: emptyRequest(),
      RequestTable: [],
      modal: false,
      modalInspectors: false,
      modalAuditors: false,
      modalInspectorsInfo: false,
      isLoading: false,
      isSave: false,
      items: [],
      filter1: {
        page: 1,
        pageSize: 10,
        totalRows: 1,
        search: "",
      },
      fields: [
        {
          key: "isSelected",
          label: this.$t("isSelected"),
        },
        { key: "employeeId", label: "ID", sort: true },
        { key: "fullName", label: this.$t("fullname"), sort: true },
      ],
      tabrow: {
        id: 0,
        inspectionBookId: 0,
        fullName: "",
        workplace: "",
        directionOfActivity: "",
        contractNumber: "",
      },
      tabrowInspectors: {
        id: 0,
        inspectionBookId: 0,
        organizationName: "",
        address: "",
        inspectorFullName: "",
        dutyNumber: "",
        dutyExpiration: "",
        contractNumber: "",
        contractExpiration: "",
        dutyIssuingOrganization: "",
        certificateNumber: "",
        certificateIssuingOrganization: "",
        certificateExpiration: "",
      },
      tabrowAuditors: {
        id: 0,
        inspectionBookId: 0,
        organizationName: "",
        licenseDate: "",
        licenseNumber: "",
        licenseExpiration: "",
        auditorFullName: "",
        contractNumber: "",
        contractExpiration: "",
      },
      editedIndex1: -1,
      editedIndex: -1,
      editedIndex2: -1,
      show: false,
      stage: "",
      part: "",
      searched: false,
      searchInn: "",
      isSearching: false,
      ControlFunctionList: [],
      ParentList: [],
      OrganizationList: [],
      rating: {
        loaded: false,
        loading: false,
        submitting: false,
        alreadyRated: false,
        error: "",
        inspectors: [],
        inspectionRating: 0,
        inspectionComment: "",
        inspectorsRating: 0,
        inspectorsComment: "",
      },
    };
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BBadge,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BLink,
    BOverlay,
    BFormRating,
    customDatePicker,
    customInput,
    customTextarea,
    vSelect,
  },
  computed: {
    // Sarlavha tanlangan bosqichga qarab chiqadi (biznes-himoya menyusidagi matnlar bilan bir xil)
    pageTitle() {
      if (this.stage === "notified") return this.$t("BHStageNotified");
      if (this.stage === "24h") return this.$t("BHStage24h");
      if (this.isCriminal) return this.$t("BHStageCriminal");
      return this.$t("inspectionbook");
    },
    isContractor() {
      return this.part === "contractor";
    },
    isControl() {
      return this.part === "control";
    },
    // Jinoyat ishlari doirasidagi tekshiruvda 1, 2 va 6-punktlar ko'rsatilmaydi,
    // 5-punkt esa birinchi bo'lib chiqadi.
    isCriminal() {
      return this.stage === "criminal";
    },
    showDocNumber5() {
      return this.stage !== "24h" && !this.isCriminal;
    },
    controlPunktCount() {
      return this.isCriminal ? 4 : 7;
    },
    showControlPart() {
      return this.part !== "contractor";
    },
    showContractorPart() {
      return this.part !== "control";
    },
    controlDisabled() {
      return this.Request.statusId == 2 || this.isContractor;
    },
    contractorDisabled() {
      return this.Request.statusId == 2 || !this.isContractor;
    },
    canSubmitRating() {
      if (this.rating.inspectionRating < 1) return false;
      if (this.rating.inspectors.length && this.rating.inspectorsRating < 1) return false;
      return true;
    },
  },
  created() {
    this.stage = this.$route.query.stage || "";
    this.part = this.$route.query.part || "";
    this.LoadControlFunctions();
    this.LoadParentList();
    this.Refresh();
  },
  methods: {
    contractorPunktNumber(localIndex) {
      return this.showControlPart
        ? localIndex + this.controlPunktCount
        : localIndex;
    },
    // Jinoyat ishlari doirasidagi tekshiruvda punktlar tartibi: 5, 3, 4, 7
    punktNumber(punkt) {
      if (!this.isCriminal) return punkt;
      return CRIMINAL_PUNKT_ORDER[punkt] || punkt;
    },
    punktStyle(punkt) {
      if (!this.isCriminal) return {};
      return { order: CRIMINAL_PUNKT_ORDER[punkt] };
    },
    NormalizeRequest(data) {
      data = data || {};
      if (!data.contractor) data.contractor = emptyContractor();
      if (!data.involvedInspectors) data.involvedInspectors = [];
      if (!data.involvedAuditors) data.involvedAuditors = [];
      if (!data.specialists) data.specialists = [];
      if (!data.inspectors) data.inspectors = [];
      if (!data.controlFunctions) data.controlFunctions = [];
      if (data.orderedOrganizationId === 0) data.orderedOrganizationId = null;
      if (data.inspectionOrganizationId === 0)
        data.inspectionOrganizationId = null;
      const dateFields = [
        "docDate",
        "orderDate",
        "startDate",
        "endDate",
        "contractorStartDate",
        "contractorEndDate",
      ];
      dateFields.forEach((f) => {
        data[f] = this.ToDateString(data[f]);
      });
      (data.inspectors || []).forEach((it) => {
        it.certificateExpiration = this.ToDateString(it.certificateExpiration);
        it.dutyExpiration = this.ToDateString(it.dutyExpiration);
      });
      (data.involvedInspectors || []).forEach((it) => {
        it.dutyExpiration = this.ToDateString(it.dutyExpiration);
        it.contractExpiration = this.ToDateString(it.contractExpiration);
        it.certificateExpiration = this.ToDateString(it.certificateExpiration);
      });
      (data.involvedAuditors || []).forEach((it) => {
        it.licenseDate = this.ToDateString(it.licenseDate);
        it.licenseExpiration = this.ToDateString(it.licenseExpiration);
        it.contractExpiration = this.ToDateString(it.contractExpiration);
      });
      (data.specialists || []).forEach((it) => {
        it.contractExpiration = this.ToDateString(it.contractExpiration);
      });
      return data;
    },
    NullIfZero(v) {
      return v === 0 || v === "0" || v === "" ? null : v;
    },
    // API sanani ISO ko'rinishida qaytaradi, date-picker esa DD.MM.YYYY kutadi
    ToDateString(value) {
      if (!value || typeof value !== "string") return "";
      if (value.indexOf(".") > -1) return value.slice(0, 10);
      var parts = value.split("T")[0].split("-");
      if (parts.length !== 3) return value;
      return `${parts[2]}.${parts[1]}.${parts[0]}`;
    },
    // API ba'zan Task<T> ko'rinishida javob qaytaradi (asyncState, isCompleted, result...),
    // bunda haqiqiy DTO `result` ichida bo'ladi
    Unwrap(data) {
      if (
        data &&
        typeof data === "object" &&
        Object.prototype.hasOwnProperty.call(data, "result") &&
        ("isCompleted" in data || "isFaulted" in data || "asyncState" in data)
      ) {
        return data.result;
      }
      return data;
    },
    // CriminalCaseInspectionDto -> shu formadagi Request ko'rinishiga
    NormalizeCriminalRequest(data) {
      data = data || {};
      var request = emptyRequest();
      request.id = data.id || 0;
      request.statusId = data.statusId || 0;
      request.requestId = data.requestId || null;
      request.contractor = data.contractor || emptyContractor();
      request.orderCode = data.orderCode || "";
      request.docNumber = data.docNumber || "";
      request.sequenceNumber = data.sequenceNumber || "";
      request.orderNumber = data.orderNumber || "";
      request.criminalCaseInfo = data.criminalCaseInfo || "";
      request.inspectionTypeId = data.inspectionTypeId || null;
      request.checkDaysNumber = data.checkDaysNumber || 0;
      request.message = data.message || "";
      request.docDate = this.ToDateString(data.docDate);
      request.orderDate = this.ToDateString(data.orderDate);
      request.startDate = this.ToDateString(data.startDate);
      request.endDate = this.ToDateString(data.endDate);
      request.inspectors = (data.officials || []).map((item) => ({
        id: item.id || 0,
        employeeId: item.employeeId,
        fullName: item.fullName || "",
        dutyNumber: item.dutyNumber || "",
        dutyExpiration: this.ToDateString(item.dutyExpiration),
        certificateNumber: item.certificateNumber || "",
        certificateExpiration: this.ToDateString(item.certificateExpiration),
      }));
      request.involvedInspectors = (data.involvedInspectors || []).map(
        (item) => ({
          ...item,
          contractExpiration: this.ToDateString(item.contractExpiration),
          certificateExpiration: this.ToDateString(item.certificateExpiration),
        })
      );
      request.involvedAuditors = (data.auditors || []).map((item) => ({
        ...item,
        licenseDate: this.ToDateString(item.licenseDate),
        licenseExpiration: this.ToDateString(item.licenseExpiration),
        contractExpiration: this.ToDateString(item.contractExpiration),
      }));
      request.specialists = (data.experts || []).map((item) => ({
        ...item,
        contractExpiration: this.ToDateString(item.contractExpiration),
      }));
      return request;
    },
    // Request -> Create/UpdateCriminalCaseInspectionDlDto
    BuildCriminalData() {
      var inspectionId = this.Request.id || 0;
      var contractor = this.Request.contractor || {};
      return {
        id: inspectionId,
        requestId: this.Request.requestId || null,
        orderCode: this.Request.orderCode || null,
        docNumber: this.Request.docNumber || null,
        contractorId: contractor.id,
        docDate: this.Request.docDate || null,
        sequenceNumber: this.Request.sequenceNumber || null,
        orderNumber: this.Request.orderNumber || null,
        orderDate: this.Request.orderDate || null,
        criminalCaseInfo: this.Request.criminalCaseInfo || null,
        inspectionTypeId: this.NullIfZero(this.Request.inspectionTypeId),
        startDate: this.Request.startDate || null,
        endDate: this.Request.endDate || null,
        checkDaysNumber: Number(this.Request.checkDaysNumber) || 0,
        statusId: this.Request.statusId || 0,
        message: this.Request.message || null,
        officials: (this.RequestTable || []).map((item) => ({
          id: item.id || 0,
          criminalCaseInspectionId: inspectionId,
          employeeId: item.employeeId,
          dutyNumber: item.dutyNumber || null,
          dutyExpiration: item.dutyExpiration || null,
          certificateNumber: item.certificateNumber || null,
          certificateExpiration: item.certificateExpiration || null,
        })),
        involvedInspectors: (this.Request.involvedInspectors || []).map(
          (item) => ({
            id: item.id || 0,
            criminalCaseInspectionId: inspectionId,
            organizationName: item.organizationName,
            address: item.address || null,
            inspectorFullName: item.inspectorFullName,
            contractNumber: item.contractNumber,
            contractExpiration: item.contractExpiration || null,
            dutyIssuingOrganization: item.dutyIssuingOrganization || null,
            certificateNumber: item.certificateNumber || null,
            certificateIssuingOrganization:
              item.certificateIssuingOrganization || null,
            certificateExpiration: item.certificateExpiration || null,
          })
        ),
        auditors: (this.Request.involvedAuditors || []).map((item) => ({
          id: item.id || 0,
          criminalCaseInspectionId: inspectionId,
          organizationName: item.organizationName,
          licenseDate: item.licenseDate,
          licenseNumber: item.licenseNumber,
          licenseExpiration: item.licenseExpiration,
          auditorFullName: item.auditorFullName,
          contractNumber: item.contractNumber,
          contractExpiration: item.contractExpiration,
        })),
        experts: (this.Request.specialists || []).map((item) => ({
          id: item.id || 0,
          criminalCaseInspectionId: inspectionId,
          fullName: item.fullName,
          contractNumber: item.contractNumber,
          identificationDocument: item.identificationDocument || null,
          contractExpiration: item.contractExpiration || null,
        })),
      };
    },
    LoadControlFunctions() {
      ControlFunctionService.GetAsSelectList(0)
        .then((res) => {
          this.ControlFunctionList = res.data || [];
        })
        .catch(() => {
          this.ControlFunctionList = [];
        });
    },
    LoadParentList() {
      ManualService.GetOrganizationAsSelectList("", false, true)
        .then((res) => {
          this.ParentList = res.data || [];
        })
        .catch(() => {
          this.ParentList = [];
        });
    },
    ChangeOrganization() {
      this.Request.inspectionOrganizationId = 0;
      this.Request.inspectionOrganizationName = "";
      if (!this.Request.orderedOrganizationId) {
        this.OrganizationList = [];
        return;
      }
      this.Request.orderedOrganization = (
        this.ParentList.find(
          (item) => item.value === this.Request.orderedOrganizationId
        ) || {}
      ).text || "";
      ManualService.GetOrganizationAsSelectList(
        this.Request.orderedOrganizationId,
        false,
        true
      )
        .then((res) => {
          this.OrganizationList = res.data || [];
        })
        .catch(() => {
          this.OrganizationList = [];
        });
    },
    ChangeInspectionOrganization() {
      this.Request.inspectionOrganization = "";
      this.Request.inspectionOrganizationName = "";
      if (this.Request.inspectionOrganizationId) {
        const found = this.OrganizationList.find(
          (item) => item.value === this.Request.inspectionOrganizationId
        );
        if (found) {
          this.Request.inspectionOrganization = found.text;
          this.Request.inspectionOrganizationName = found.text;
        }
        ControlFunctionService.GetAsSelectList(
          this.Request.orderedOrganizationId
        )
          .then((res) => {
            this.ControlFunctionList = res.data || [];
          })
          .catch(() => { });
      }
    },
    Refresh() {
      const id = this.$route.params.id;
      if (id && id != 0) {
        this.show = true;
        var request = this.isCriminal
          ? CriminalCaseInspectionService.Get(id)
          : InspectionBookService.Get(id);
        request
          .then((res) => {
            var data = this.Unwrap(res.data);
            this.Request = this.isCriminal
              ? this.NormalizeCriminalRequest(data)
              : this.NormalizeRequest(data || emptyRequest());
            this.RequestTable = this.Request.inspectors || [];
            this.searched = true;
            this.show = false;
            if (this.Request && this.Request.docNumber) {
              this.loadRating(this.Request.docNumber);
            }
          })
          .catch((error) => {
            this.Request = emptyRequest();
            this.RequestTable = [];
            this.show = false;
            if (error.response && error.response.data) {
              this.makeToast(error.response.data, "error");
            }
          });
      }
    },
    loadRating(docNumber) {
      this.rating.loading = true;
      this.rating.error = "";
      RequestRatingService.GetByDocNumber(docNumber)
        .then((res) => {
          const d = (res && res.data) || {};
          const names = Array.isArray(d.inspectorNames) ? d.inspectorNames : [];
          this.rating.inspectors = names;
          return RequestRatingService.GetList({
            search: docNumber,
            sortBy: "",
            orderType: "",
            page: 1,
            pageSize: 20,
          })
            .then((r) => {
              const rows = (r && r.data && (r.data.rows || r.data.items)) || [];
              const own = rows.filter((x) => x.docNumber === docNumber);
              if (own.length) {
                this.rating.alreadyRated = true;
                const req = own.find((x) => x.isRequest);
                const ins = own.find((x) => !x.isRequest);
                if (req) {
                  this.rating.inspectionRating = req.rating || 0;
                  this.rating.inspectionComment = req.text || "";
                }
                if (ins) {
                  this.rating.inspectorsRating = ins.rating || 0;
                  this.rating.inspectorsComment = ins.text || "";
                }
              }
            })
            .catch(() => { /* ignore — assume not rated */ });
        })
        .catch(() => { /* docNumber lookup failed — leave inspectors empty */ })
        .finally(() => {
          this.rating.loading = false;
          this.rating.loaded = true;
        });
    },
    extractRatingError(err) {
      const fallback = this.$t("RatingSubmitError") || "Baholashni yuborishda xatolik";
      const data = err && err.response && err.response.data;
      if (!data) return fallback;
      if (typeof data === "string" && data.trim()) return data;
      if (data.errors && typeof data.errors === "object") {
        const msgs = [];
        Object.values(data.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else if (typeof v === "string") msgs.push(v);
        });
        if (msgs.length) return Array.from(new Set(msgs)).join("; ");
      }
      if (data.message) return data.message;
      if (data.title) return data.title;
      return fallback;
    },
    submitRating() {
      if (!this.canSubmitRating || this.rating.submitting) return;
      this.rating.submitting = true;
      this.rating.error = "";
      const docNumber = this.Request.docNumber;
      const payloads = [
        {
          docNumber: docNumber,
          rating: this.rating.inspectionRating,
          isRequest: true,
          text: this.rating.inspectionComment || "",
        },
      ];
      if (this.rating.inspectors.length && this.rating.inspectorsRating > 0) {
        payloads.push({
          docNumber: docNumber,
          rating: this.rating.inspectorsRating,
          isRequest: false,
          text: this.rating.inspectorsComment || "",
        });
      }
      Promise.all(payloads.map((p) => RequestRatingService.Create(p)))
        .then(() => {
          this.rating.alreadyRated = true;
          this.makeToast(this.$t("RatingSubmitted") || "Baholash yuborildi", "success");
        })
        .catch((err) => {
          this.rating.error = this.extractRatingError(err);
        })
        .finally(() => {
          this.rating.submitting = false;
        });
    },
    SearchByInnOrPinfl() {
      if (!this.searchInn) {
        this.makeToast(this.$t("inn") + " / " + this.$t("pinfl"), "error");
        return;
      }
      this.isSearching = true;
      this.show = true;
      var request = this.isCriminal
        ? CriminalCaseInspectionService.GetByInnOrPinfl(this.searchInn)
        : InspectionBookService.GetByInnOrPinfl(this.searchInn);
      request
        .then((res) => {
          var data = this.Unwrap(res.data);
          this.Request = this.isCriminal
            ? this.NormalizeCriminalRequest(data)
            : this.NormalizeRequest(data || emptyRequest());
          if (!this.Request.contractor.innOrPinfl) {
            this.Request.contractor.innOrPinfl = this.searchInn;
          }
          this.RequestTable = this.Request.inspectors || [];
          this.searched = true;
          this.isSearching = false;
          this.show = false;
          if (this.Request && this.Request.docNumber) {
            this.loadRating(this.Request.docNumber);
          }
        })
        .catch((error) => {
          this.isSearching = false;
          this.show = false;
          if (error.response && error.response.data) {
            this.makeToast(error.response.data.errors || error.response.data, "error");
          }
        });
    },
    AddNewInspectors() {
      this.modalInspectorsInfo = true;
      this.isLoading = true;
      InspectorService.GetAsSelectList({
        parentOrganizationId: this.Request.orderedOrganizationId,
        organizationId: this.Request.inspectionOrganizationId,
        isHr: false,
        isPassedAttestation: true,
        search: this.filter1.search,
        sortBy: this.filter1.sortBy,
        orderType: this.filter1.orderType,
        page: this.filter1.page,
        pageSize: this.filter1.pageSize,
      }).then((res) => {
        var ids = this.RequestTable.map((item) => item.employeeId);
        this.items = [];
        for (let i = 0; i < res.data.rows.length; i++) {
          this.items.push({
            fullName: res.data.rows[i].text,
            certificateExpiration: res.data.rows[i].expirationDate,
            certificateNumber: res.data.rows[i].certificateNumber,
            employeeId: res.data.rows[i].value,
            isSelected: ids.includes(res.data.rows[i].value),
          });
        }
        this.filter1.totalRows = res.data.total;
        this.isLoading = false;
      });
    },
    AddInspectorsTableInfo() {
      this.items.forEach((item) => {
        if (item.isSelected) {
          var duplicateInspector = this.RequestTable.map(
            (item) => item.employeeId
          );
          if (duplicateInspector.includes(item.employeeId)) {
            return false;
          } else {
            this.RequestTable.push(item);
          }
        }
      });
      this.modalInspectorsInfo = false;
    },
    modalInspectorsInfoClose() {
      this.modalInspectorsInfo = false;
    },
    DeleteInspector(item, index) {
      this.RequestTable.splice(index, 1);
    },
    DeleteInvolvedInspector(index) {
      this.Request.involvedInspectors.splice(index, 1);
    },
    DeleteSpecialists(index) {
      this.Request.specialists.splice(index, 1);
    },
    DeleteAuditors(index) {
      this.Request.involvedAuditors.splice(index, 1);
    },
    BackModal() {
      this.modal = false;
    },
    modalInspectorsClose() {
      this.modalInspectors = false;
    },
    modalAuditorsClose() {
      this.modalAuditors = false;
    },
    AddSpecialists() {
      this.modal = true;
      this.editedIndex1 = -1;
      this.tabrow = {
        id: 0,
        inspectionBookId: 0,
        fullName: "",
        workplace: "",
        directionOfActivity: "",
        contractNumber: "",
      };
    },
    AddAuditors() {
      this.modalAuditors = true;
      this.editedIndex = -1;
      this.tabrowAuditors = {
        id: 0,
        inspectionBookId: 0,
        organizationName: "",
        licenseDate: "",
        licenseNumber: "",
        licenseExpiration: "",
        auditorFullName: "",
        contractNumber: "",
        contractExpiration: "",
      };
    },
    AddInspectors() {
      this.modalInspectors = true;
      this.editedIndex2 = -1;
      this.tabrowInspectors = {
        id: 0,
        inspectionBookId: 0,
        organizationName: "",
        address: "",
        inspectorFullName: "",
        dutyNumber: "",
        dutyExpiration: "",
        contractNumber: "",
        contractExpiration: "",
        dutyIssuingOrganization: "",
        certificateNumber: "",
        certificateIssuingOrganization: "",
        certificateExpiration: "",
      };
    },
    back() {
      this.$router.go(-1);
    },
    EditSpecialists(item) {
      this.modal = true;
      this.editedIndex1 = this.Request.specialists.indexOf(item);
      this.tabrow = Object.assign({}, item);
    },
    EditAuditors(item) {
      this.modalAuditors = true;
      this.editedIndex = this.Request.involvedAuditors.indexOf(item);
      this.tabrowAuditors = Object.assign({}, item);
    },
    EditInvolvedInspector(item) {
      this.modalInspectors = true;
      this.editedIndex2 = this.Request.involvedInspectors.indexOf(item);
      this.tabrowInspectors = Object.assign({}, item);
    },
    AddOked() {
      if (this.editedIndex1 > -1) {
        Object.assign(this.Request.specialists[this.editedIndex1], this.tabrow);
      } else {
        this.Request.specialists.push({ ...this.tabrow });
      }
      this.modal = false;
      this.editedIndex1 = -1;
      this.tabrow = {};
    },
    AddAuditorsTable() {
      if (this.editedIndex > -1) {
        Object.assign(
          this.Request.involvedAuditors[this.editedIndex],
          this.tabrowAuditors
        );
      } else {
        this.Request.involvedAuditors.push({ ...this.tabrowAuditors });
      }
      this.modalAuditors = false;
      this.editedIndex = -1;
      this.tabrowAuditors = {};
    },
    AddInspectorsTable() {
      if (this.editedIndex2 > -1) {
        Object.assign(
          this.Request.involvedInspectors[this.editedIndex2],
          this.tabrowInspectors
        );
      } else {
        this.Request.involvedInspectors.push({ ...this.tabrowInspectors });
      }
      this.modalInspectors = false;
      this.editedIndex2 = -1;
      this.tabrowInspectors = {};
    },
    ValidateBeforeSave() {
      var errors = [];
      if (this.showControlPart) {
        if (this.isCriminal && !this.Request.criminalCaseInfo) {
          errors.push(
            this.$t("fieldRequired", { field: this.$t("criminalCaseInfo") })
          );
        }
        if (!this.Request.startDate) {
          errors.push(this.$t("fieldRequired", { field: this.$t("startDate") }));
        }
        if (!this.Request.endDate) {
          errors.push(this.$t("fieldRequired", { field: this.$t("endDate") }));
        }
        if (!this.RequestTable || this.RequestTable.length === 0) {
          errors.push(this.$t("atLeastOneInspector"));
        } else {
          this.RequestTable.forEach((row) => {
            if (!row.fullName) {
              errors.push(
                this.$t("fieldRequired", { field: this.$t("inspectorFullName") })
              );
            }
          });
        }
      }
      // Bir xil xabarlarni takrorламаслик учун
      return Array.from(new Set(errors));
    },
    SaveData() {
      var validationErrors = this.ValidateBeforeSave();
      if (validationErrors.length) {
        var message =
          this.$t("fillRequiredFields") +
          "\n" +
          validationErrors.map((e, i) => i + 1 + ". " + e).join("\n");
        this.makeToast(message, "error");
        return;
      }
      this.isSave = true;
      // Jinoyat ishlari doirasidagi tekshiruv alohida API'ga yoziladi
      if (this.isCriminal) {
        CriminalCaseInspectionService.Save(this.BuildCriminalData())
          .then(() => {
            this.isSave = false;
            this.makeToast(this.$t("SendSuccess"), "success");
            this.$router.push({ name: "BiznesHimoya" });
          })
          .catch((error) => {
            this.isSave = false;
            if (error.response && error.response.data) {
              this.makeToast(
                error.response.data.errors || error.response.data,
                "error"
              );
            }
          });
        return;
      }
      var data = {
        id: this.Request.id || 0,
        statusId: this.Request.statusId || 0,
        stage: this.stage,
        part: this.part,
        contractor: this.Request.contractor,
        contractorId: this.Request.contractor.id,
        orderedOrganizationId: this.NullIfZero(this.Request.orderedOrganizationId),
        inspectionOrganizationId: this.NullIfZero(this.Request.inspectionOrganizationId),
        orderedOrganization: this.Request.orderedOrganization,
        inspectionOrganization: this.Request.inspectionOrganization,
        authorizedOrganization: this.Request.authorizedOrganization,
        inspectionOrganizationAddres: this.Request.inspectionOrganizationAddres,
        inspectionOrganizationCeo: this.Request.inspectionOrganizationCeo,
        inspectionOrganizationName: this.Request.inspectionOrganizationName,
        criminalCaseInfo: this.Request.criminalCaseInfo,
        inspectionOrganizationPostalAddres: this.Request
          .inspectionOrganizationPostalAddres,
        docNumber: this.Request.docNumber,
        orderNumber: this.Request.orderNumber,
        orderDate: this.Request.orderDate,
        requestId: this.Request.requestId,
        docDate: this.Request.docDate,
        startDate: this.Request.startDate,
        endDate: this.Request.endDate,
        checkDaysNumber: this.Request.checkDaysNumber,
        contractorStartDate: this.Request.contractorStartDate,
        contractorEndDate: this.Request.contractorEndDate,
        contractorCheckDaysNumber: this.Request.contractorCheckDaysNumber,
        requestedDocuments: this.Request.requestedDocuments,
        takenMeasures: this.Request.takenMeasures,
        thirdPartyInfo: this.Request.thirdPartyInfo,
        rate: this.Request.rate,
        controlFunctions: this.Request.controlFunctions,
        inspectors: this.RequestTable,
        involvedAuditors: this.Request.involvedAuditors,
        involvedInspectors: this.Request.involvedInspectors,
        specialists: this.Request.specialists,
        comment: this.Request.comment,
      };

      var request =
        this.part === "contractor"
          ? InspectionBookService.CreateAnonymousByContractor(data)
          : InspectionBookService.CreateAnonymous(data);

      request
        .then(() => {
          this.isSave = false;
          this.makeToast(this.$t("SendSuccess"), "success");
          this.$router.push({ name: "BiznesHimoya" });
        })
        .catch((error) => {
          this.isSave = false;
          if (error.response && error.response.data) {
            this.makeToast(error.response.data.errors || error.response.data, "error");
          }
        });
    },
    makeToast(message, type) {
      var a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400) {
        var errors = Object.values(message.errors);
        a = errors.map((el, item) => item + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style>
/* Punktlarni CSS `order` orqali qayta tartiblash uchun */
.ib-punkt-list {
  display: flex;
  flex-direction: column;
}

.cardStyleEdit {
  padding: 5px;
  background-color: #eaf2ff;
  border-radius: 5px;
}

.styleText {
  font-weight: 900;
}

.my-select .vs__dropdown-toggle {
  background-color: #f7f7f7;
  border: none;
  border-radius: 12px;
  padding: 14px 8px 6px;
  min-height: 54px;
  box-shadow: none;
}

.my-select .vs__search,
.my-select .vs__search:focus {
  margin: 0;
  padding-left: 8px;
  font-size: 14px;
}

.my-select .vs__selected {
  margin-left: 8px;
  margin-top: 2px;
  font-size: 14px;
  color: #333;
}

.my-select .vs__selected-options {
  padding: 0;
}

.my-select .vs__actions {
  padding-right: 10px;
}

.my-select.vs--disabled .vs__dropdown-toggle,
.my-select.vs--disabled .vs__search,
.my-select.vs--disabled .vs__selected {
  background-color: #f7f7f7;
  cursor: not-allowed;
}

.my-select .vs__dropdown-menu {
  border-radius: 12px;
  border: none;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

/* Rating block */
.rt-card {
  background: #fff;
  border: 1px solid #e3e6ee;
  border-radius: 14px;
  overflow: hidden;
}
.rt-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eef0f5;
  gap: 12px;
  flex-wrap: wrap;
}
.rt-card-head h2 {
  font-size: 16px;
  font-weight: 800;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1c2238;
}
.rt-hint { font-size: 12px; color: #6b7388; }
.rt-card-body {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.rt-already {
  background: #d1fae5;
  color: #065f46;
  padding: 10px 14px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-rate-block {
  padding: 14px;
  background: #f8f9fc;
  border-radius: 12px;
  border: 1px solid #eef0f5;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.rt-who { display: flex; align-items: center; gap: 12px; }
.rt-who-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #eef2fb;
  color: #2a3b5d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.rt-who-lbl {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #8a92a8;
}
.rt-who-nm { font-size: 14px; font-weight: 700; color: #1c2238; }
.rt-insp-names {
  list-style: none;
  margin: 0;
  padding: 10px 14px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rt-insp-names li {
  font-size: 13px;
  color: #1c2238;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-insp-names li i { color: #2a3b5d; font-size: 12px; }
.rt-stars { display: flex; align-items: center; gap: 4px; }
.rt-star {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #d9dde6;
  font-size: 22px;
  transition: color 0.15s;
}
.rt-star:hover:not(:disabled) { color: #f5b800; }
.rt-star.filled { color: #f5b800; }
.rt-star:disabled { cursor: default; opacity: 0.85; }
.rt-stars-val { margin-left: 8px; font-size: 13px; color: #4a526a; font-weight: 700; }
.rt-comment {
  width: 100%;
  border: 1.5px solid #e3e6ee;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  min-height: 70px;
  resize: vertical;
  outline: none;
  background: #fff;
  color: #1c2238;
}
.rt-comment:focus { border-color: #2a3b5d; }
.rt-comment:disabled { background: #f8f9fc; color: #4a526a; }
.rt-error {
  background: #fdecec;
  border: 1px solid #f6c0c0;
  color: #b43a3a;
  padding: 9px 12px;
  border-radius: 8px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-actions {
  padding: 14px 20px;
  border-top: 1px solid #eef0f5;
  display: flex;
  justify-content: flex-end;
}
.rt-btn {
  padding: 9px 22px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border: 1.5px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  transition: background 0.15s, opacity 0.15s;
}
.rt-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.rt-btn.primary { background: #2a3b5d; color: #fff; border-color: #2a3b5d; }
.rt-btn.primary:hover:not(:disabled) { background: #1f2d4a; }
</style>
